import { Button as AntdButton, Input, Modal } from 'antd';
import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';

export const CustomLaborModal = styled(Modal)(({ theme }) => ({
  '.ant-modal-body': {
    fontFamily: theme.typography.family.arial,
    fontSize: theme.typography.size16,
    color: theme.page.subtitle.text,
    lineHeight: 1,
  },

  '.labor_notes': {
    inlineSize: '200rem',
  },
}));

export const CustomLaborModalTitle = styled.h2(({ theme }) => ({
  color: theme.page.title.text,
  fontFamily: theme.typography.family.playfairDisplay,
  fontSize: theme.typography.size24,
  marginBottom: '30rem',
}));

export const RemoveOptionButton = styled.button(() => ({
  border: 'none',
  background: 'none',
  cursor: 'pointer',

  '&:hover': {
    opacity: 0.5,
  },

  '.ant-image': {
    width: '12rem',
  },
}));

export const ButtonsContainer = styled.div(() => ({
  display: 'flex',
  gap: '3rem',
  width: '100%',
  marginLeft: 'auto',
}));

export const Button = styled(CommonButton)(() => ({
  paddingInline: '20rem',
  fontSize: '20rem',
}));

export const AddButton = styled(Button)(() => ({
  marginLeft: 'auto',
  marginRight: '20rem',
}));

export const AddRowButton = styled(AntdButton)(() => ({
  paddingInline: '20rem',
  fontSize: '14rem',
}));

export const AddRowButtonContentWrapper = styled.div(({ theme }) => ({
  color: theme.palette.artichoke,
  display: 'flex',
  gap: '9rem',
  '&:hover': {
    color: theme.palette.artichoke,
    fontWeight: 'bold',
    fontStyle: 'italic',
  },
}));

export const TotalLabel = styled.div(({ theme }) => ({
  color: theme.palette.darkLiver,
  textAlign: 'end',
  marginBottom: '20rem',
}));

export const TableInput = styled(Input)(({ theme }) => ({
  textAlign: 'center',
  '&.zero-price': {
    opacity: 0.5,
  },
  '&.has-error': {
    borderColor: theme.palette.red,
  },
}));

export const TablePriceLabel = styled.div(() => ({
  '&.zero-price': {
    opacity: 0.25,
  },
}));

export const ErrorMessage = styled.div(({ theme }) => ({
  color: theme.palette.red,
  fontSize: '12rem',
  marginTop: '5rem',
  textAlign: 'center',
  fontStyle: 'italic',
}));
